import humanize, { OptionalLanguages } from "humanize-duration";
import moment from "moment";
import { IUserAnalytics } from "../App/Analytics/Common";
import { humanizeFormat } from "../utils";

export const lastSeenValue = (ua?: IUserAnalytics): string => {
  if (!ua || ua.lastSeen === null) {
    return "Never seen";
  } else {
    return moment(ua.lastSeen).format("DD MMM YY HH:mm");
  }
};

export const timeTakenValue = (ua?: IUserAnalytics): string => {
  if (!ua || ua.time === 0) {
    return "0 s";
  } else {
    return humanize<"shortEng">(ua.time, {
      delimiter: " ",
      language: "shortEng",
      languages: {
        shortEng: {
          h: _ => "h",
          m: _ => "min",
          s: _ => "sec",
        },
      } as OptionalLanguages<"shortEng">,
      round: true,
      ...humanizeFormat(ua.time),
    });
  }
};
